export default function once<A extends unknown[], R>(func: (...args: A) => R): (...args: A) => R | undefined {
  let isCalled = false;

  return (...args: A): R | undefined => {
    if (isCalled) return undefined;
    isCalled = true;
    return func(...args);
  };
}
